var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5C9.61929 8.5 8.5 9.61929 8.5 11V12.25C8.5 12.5952 8.77983 12.875 9.125 12.875C9.47017 12.875 9.75 12.5952 9.75 12.25V11C9.75 10.3096 10.3096 9.75 11 9.75H12.25C12.5952 9.75 12.875 9.47017 12.875 9.125C12.875 8.77983 12.5952 8.5 12.25 8.5H11Z",
    fill: "#0D0D0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 8.5C19.4048 8.5 19.125 8.77983 19.125 9.125C19.125 9.47017 19.4048 9.75 19.75 9.75H21C21.6903 9.75 22.25 10.3096 22.25 11V12.25C22.25 12.5952 22.5298 12.875 22.875 12.875C23.2202 12.875 23.5 12.5952 23.5 12.25V11C23.5 9.61929 22.3807 8.5 21 8.5H19.75Z",
    fill: "#0D0D0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 19.75C9.75 19.4048 9.47017 19.125 9.125 19.125C8.77983 19.125 8.5 19.4048 8.5 19.75V21C8.5 22.3807 9.61929 23.5 11 23.5H12.25C12.5952 23.5 12.875 23.2202 12.875 22.875C12.875 22.5298 12.5952 22.25 12.25 22.25H11C10.3096 22.25 9.75 21.6903 9.75 21V19.75Z",
    fill: "#0D0D0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19.75C23.5 19.4048 23.2202 19.125 22.875 19.125C22.5298 19.125 22.25 19.4048 22.25 19.75V21C22.25 21.6903 21.6903 22.25 21 22.25H19.75C19.4048 22.25 19.125 22.5298 19.125 22.875C19.125 23.2202 19.4048 23.5 19.75 23.5H21C22.3807 23.5 23.5 22.3807 23.5 21V19.75Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.1c07877ca06e2c0d14b3572c17f0d6df.svg";
export { ForwardRef as ReactComponent };